function $(n) {
  return n ? typeof n == "string" ? n : n.source : null;
}
function N(n) {
  return e("(?=", n, ")");
}
function e(...n) {
  return n.map((m) => $(m)).join("");
}
function Fe(n) {
  const o = n[n.length - 1];
  return typeof o == "object" && o.constructor === Object ? (n.splice(n.length - 1, 1), o) : {};
}
function s(...n) {
  return "(" + (Fe(n).capture ? "" : "?:") + n.map((c) => $(c)).join("|") + ")";
}
const g = (n) => e(
  /\b/,
  n,
  /\w$/.test(n) ? /\b/ : /\B/
), Ae = [
  "Protocol",
  // contextual
  "Type"
  // contextual
].map(g), K = [
  "init",
  "self"
].map(g), be = [
  "Any",
  "Self"
], I = [
  // strings below will be fed into the regular `keywords` engine while regex
  // will result in additional modes being created to scan for those keywords to
  // avoid conflicts with other rules
  "actor",
  "any",
  // contextual
  "associatedtype",
  "async",
  "await",
  /as\?/,
  // operator
  /as!/,
  // operator
  "as",
  // operator
  "borrowing",
  // contextual
  "break",
  "case",
  "catch",
  "class",
  "consume",
  // contextual
  "consuming",
  // contextual
  "continue",
  "convenience",
  // contextual
  "copy",
  // contextual
  "default",
  "defer",
  "deinit",
  "didSet",
  // contextual
  "distributed",
  "do",
  "dynamic",
  // contextual
  "each",
  "else",
  "enum",
  "extension",
  "fallthrough",
  /fileprivate\(set\)/,
  "fileprivate",
  "final",
  // contextual
  "for",
  "func",
  "get",
  // contextual
  "guard",
  "if",
  "import",
  "indirect",
  // contextual
  "infix",
  // contextual
  /init\?/,
  /init!/,
  "inout",
  /internal\(set\)/,
  "internal",
  "in",
  "is",
  // operator
  "isolated",
  // contextual
  "nonisolated",
  // contextual
  "lazy",
  // contextual
  "let",
  "macro",
  "mutating",
  // contextual
  "nonmutating",
  // contextual
  /open\(set\)/,
  // contextual
  "open",
  // contextual
  "operator",
  "optional",
  // contextual
  "override",
  // contextual
  "postfix",
  // contextual
  "precedencegroup",
  "prefix",
  // contextual
  /private\(set\)/,
  "private",
  "protocol",
  /public\(set\)/,
  "public",
  "repeat",
  "required",
  // contextual
  "rethrows",
  "return",
  "set",
  // contextual
  "some",
  // contextual
  "static",
  "struct",
  "subscript",
  "super",
  "switch",
  "throws",
  "throw",
  /try\?/,
  // operator
  /try!/,
  // operator
  "try",
  // operator
  "typealias",
  /unowned\(safe\)/,
  // contextual
  /unowned\(unsafe\)/,
  // contextual
  "unowned",
  // contextual
  "var",
  "weak",
  // contextual
  "where",
  "while",
  "willSet"
  // contextual
], x = [
  "false",
  "nil",
  "true"
], fe = [
  "assignment",
  "associativity",
  "higherThan",
  "left",
  "lowerThan",
  "none",
  "right"
], he = [
  "#colorLiteral",
  "#column",
  "#dsohandle",
  "#else",
  "#elseif",
  "#endif",
  "#error",
  "#file",
  "#fileID",
  "#fileLiteral",
  "#filePath",
  "#function",
  "#if",
  "#imageLiteral",
  "#keyPath",
  "#line",
  "#selector",
  "#sourceLocation",
  "#warning"
], G = [
  "abs",
  "all",
  "any",
  "assert",
  "assertionFailure",
  "debugPrint",
  "dump",
  "fatalError",
  "getVaList",
  "isKnownUniquelyReferenced",
  "max",
  "min",
  "numericCast",
  "pointwiseMax",
  "pointwiseMin",
  "precondition",
  "preconditionFailure",
  "print",
  "readLine",
  "repeatElement",
  "sequence",
  "stride",
  "swap",
  "swift_unboxFromSwiftValueWithType",
  "transcode",
  "type",
  "unsafeBitCast",
  "unsafeDowncast",
  "withExtendedLifetime",
  "withUnsafeMutablePointer",
  "withUnsafePointer",
  "withVaList",
  "withoutActuallyEscaping",
  "zip"
], W = s(
  /[/=\-+!*%<>&|^~?]/,
  /[\u00A1-\u00A7]/,
  /[\u00A9\u00AB]/,
  /[\u00AC\u00AE]/,
  /[\u00B0\u00B1]/,
  /[\u00B6\u00BB\u00BF\u00D7\u00F7]/,
  /[\u2016-\u2017]/,
  /[\u2020-\u2027]/,
  /[\u2030-\u203E]/,
  /[\u2041-\u2053]/,
  /[\u2055-\u205E]/,
  /[\u2190-\u23FF]/,
  /[\u2500-\u2775]/,
  /[\u2794-\u2BFF]/,
  /[\u2E00-\u2E7F]/,
  /[\u3001-\u3003]/,
  /[\u3008-\u3020]/,
  /[\u3030]/
), Y = s(
  W,
  /[\u0300-\u036F]/,
  /[\u1DC0-\u1DFF]/,
  /[\u20D0-\u20FF]/,
  /[\uFE00-\uFE0F]/,
  /[\uFE20-\uFE2F]/
  // TODO: The following characters are also allowed, but the regex isn't supported yet.
  // /[\u{E0100}-\u{E01EF}]/u
), w = e(W, Y, "*"), j = s(
  /[a-zA-Z_]/,
  /[\u00A8\u00AA\u00AD\u00AF\u00B2-\u00B5\u00B7-\u00BA]/,
  /[\u00BC-\u00BE\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]/,
  /[\u0100-\u02FF\u0370-\u167F\u1681-\u180D\u180F-\u1DBF]/,
  /[\u1E00-\u1FFF]/,
  /[\u200B-\u200D\u202A-\u202E\u203F-\u2040\u2054\u2060-\u206F]/,
  /[\u2070-\u20CF\u2100-\u218F\u2460-\u24FF\u2776-\u2793]/,
  /[\u2C00-\u2DFF\u2E80-\u2FFF]/,
  /[\u3004-\u3007\u3021-\u302F\u3031-\u303F\u3040-\uD7FF]/,
  /[\uF900-\uFD3D\uFD40-\uFDCF\uFDF0-\uFE1F\uFE30-\uFE44]/,
  /[\uFE47-\uFEFE\uFF00-\uFFFD]/
  // Should be /[\uFE47-\uFFFD]/, but we have to exclude FEFF.
  // The following characters are also allowed, but the regexes aren't supported yet.
  // /[\u{10000}-\u{1FFFD}\u{20000-\u{2FFFD}\u{30000}-\u{3FFFD}\u{40000}-\u{4FFFD}]/u,
  // /[\u{50000}-\u{5FFFD}\u{60000-\u{6FFFD}\u{70000}-\u{7FFFD}\u{80000}-\u{8FFFD}]/u,
  // /[\u{90000}-\u{9FFFD}\u{A0000-\u{AFFFD}\u{B0000}-\u{BFFFD}\u{C0000}-\u{CFFFD}]/u,
  // /[\u{D0000}-\u{DFFFD}\u{E0000-\u{EFFFD}]/u
), T = s(
  j,
  /\d/,
  /[\u0300-\u036F\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]/
), a = e(j, T, "*"), C = e(/[A-Z]/, T, "*"), Ne = [
  "attached",
  "autoclosure",
  e(/convention\(/, s("swift", "block", "c"), /\)/),
  "discardableResult",
  "dynamicCallable",
  "dynamicMemberLookup",
  "escaping",
  "freestanding",
  "frozen",
  "GKInspectable",
  "IBAction",
  "IBDesignable",
  "IBInspectable",
  "IBOutlet",
  "IBSegueAction",
  "inlinable",
  "main",
  "nonobjc",
  "NSApplicationMain",
  "NSCopying",
  "NSManaged",
  e(/objc\(/, a, /\)/),
  "objc",
  "objcMembers",
  "propertyWrapper",
  "requires_stored_property_inits",
  "resultBuilder",
  "Sendable",
  "testable",
  "UIApplicationMain",
  "unchecked",
  "unknown",
  "usableFromInline",
  "warn_unqualified_access"
], Te = [
  "iOS",
  "iOSApplicationExtension",
  "macOS",
  "macOSApplicationExtension",
  "macCatalyst",
  "macCatalystApplicationExtension",
  "watchOS",
  "watchOSApplicationExtension",
  "tvOS",
  "tvOSApplicationExtension",
  "swift"
];
function ye(n) {
  const o = {
    match: /\s+/,
    relevance: 0
  }, m = n.COMMENT(
    "/\\*",
    "\\*/",
    { contains: ["self"] }
  ), c = [
    n.C_LINE_COMMENT_MODE,
    m
  ], X = {
    match: [
      /\./,
      s(...Ae, ...K)
    ],
    className: { 2: "keyword" }
  }, z = {
    // Consume .keyword to prevent highlighting properties and methods as keywords.
    match: e(/\./, s(...I)),
    relevance: 0
  }, H = I.filter((t) => typeof t == "string").concat(["_|0"]), q = I.filter((t) => typeof t != "string").concat(be).map(g), V = { variants: [
    {
      className: "keyword",
      match: s(...q, ...K)
    }
  ] }, u = {
    $pattern: s(
      /\b\w+/,
      // regular keywords
      /#\w+/
      // number keywords
    ),
    keyword: H.concat(he),
    literal: x
  }, r = [
    X,
    z,
    V
  ], Z = {
    // Consume .built_in to prevent highlighting properties and methods.
    match: e(/\./, s(...G)),
    relevance: 0
  }, J = {
    className: "built_in",
    match: e(/\b/, s(...G), /(?=\()/)
  }, y = [
    Z,
    J
  ], S = {
    // Prevent -> from being highlighting as an operator.
    match: /->/,
    relevance: 0
  }, Q = {
    className: "operator",
    relevance: 0,
    variants: [
      { match: w },
      {
        // dot-operator: only operators that start with a dot are allowed to use dots as
        // characters (..., ...<, .*, etc). So there rule here is: a dot followed by one or more
        // characters that may also include dots.
        match: `\\.(\\.|${Y})+`
      }
    ]
  }, E = [
    S,
    Q
  ], F = "([0-9]_*)+", O = "([0-9a-fA-F]_*)+", d = {
    className: "number",
    relevance: 0,
    variants: [
      // decimal floating-point-literal (subsumes decimal-literal)
      { match: `\\b(${F})(\\.(${F}))?([eE][+-]?(${F}))?\\b` },
      // hexadecimal floating-point-literal (subsumes hexadecimal-literal)
      { match: `\\b0x(${O})(\\.(${O}))?([pP][+-]?(${F}))?\\b` },
      // octal-literal
      { match: /\b0o([0-7]_*)+\b/ },
      // binary-literal
      { match: /\b0b([01]_*)+\b/ }
    ]
  }, D = (t = "") => ({
    className: "subst",
    variants: [
      { match: e(/\\/, t, /[0\\tnr"']/) },
      { match: e(/\\/, t, /u\{[0-9a-fA-F]{1,8}\}/) }
    ]
  }), ee = (t = "") => ({
    className: "subst",
    match: e(/\\/, t, /[\t ]*(?:[\r\n]|\r\n)/)
  }), P = (t = "") => ({
    className: "subst",
    label: "interpol",
    begin: e(/\\/, t, /\(/),
    end: /\)/
  }), A = (t = "") => ({
    begin: e(t, /"""/),
    end: e(/"""/, t),
    contains: [
      D(t),
      ee(t),
      P(t)
    ]
  }), b = (t = "") => ({
    begin: e(t, /"/),
    end: e(/"/, t),
    contains: [
      D(t),
      P(t)
    ]
  }), l = {
    className: "string",
    variants: [
      A(),
      A("#"),
      A("##"),
      A("###"),
      b(),
      b("#"),
      b("##"),
      b("###")
    ]
  }, v = [
    n.BACKSLASH_ESCAPE,
    {
      begin: /\[/,
      end: /\]/,
      relevance: 0,
      contains: [n.BACKSLASH_ESCAPE]
    }
  ], ne = {
    begin: /\/[^\s](?=[^/\n]*\/)/,
    end: /\//,
    contains: v
  }, R = (t) => {
    const h = e(t, /\//), p = e(/\//, t);
    return {
      begin: h,
      end: p,
      contains: [
        ...v,
        {
          scope: "comment",
          begin: `#(?!.*${p})`,
          end: /$/
        }
      ]
    };
  }, B = {
    scope: "regexp",
    variants: [
      R("###"),
      R("##"),
      R("#"),
      ne
    ]
  }, L = { match: e(/`/, a, /`/) }, te = {
    className: "variable",
    match: /\$\d+/
  }, se = {
    className: "variable",
    match: `\\$${T}+`
  }, _ = [
    L,
    te,
    se
  ], ae = {
    match: /(@|#(un)?)available/,
    scope: "keyword",
    starts: { contains: [
      {
        begin: /\(/,
        end: /\)/,
        keywords: Te,
        contains: [
          ...E,
          d,
          l
        ]
      }
    ] }
  }, oe = {
    scope: "keyword",
    match: e(/@/, s(...Ne))
  }, ce = {
    scope: "meta",
    match: e(/@/, a)
  }, f = [
    ae,
    oe,
    ce
  ], i = {
    match: N(/\b[A-Z]/),
    relevance: 0,
    contains: [
      {
        // Common Apple frameworks, for relevance boost
        className: "type",
        match: e(/(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)/, T, "+")
      },
      {
        // Type identifier
        className: "type",
        match: C,
        relevance: 0
      },
      {
        // Optional type
        match: /[?!]+/,
        relevance: 0
      },
      {
        // Variadic parameter
        match: /\.\.\./,
        relevance: 0
      },
      {
        // Protocol composition
        match: e(/\s+&\s+/, N(C)),
        relevance: 0
      }
    ]
  }, ie = {
    begin: /</,
    end: />/,
    keywords: u,
    contains: [
      ...c,
      ...r,
      ...f,
      S,
      i
    ]
  };
  i.contains.push(ie);
  const ue = {
    match: e(a, /\s*:/),
    keywords: "_|0",
    relevance: 0
  }, M = {
    begin: /\(/,
    end: /\)/,
    relevance: 0,
    keywords: u,
    contains: [
      "self",
      ue,
      ...c,
      B,
      ...r,
      ...y,
      ...E,
      d,
      l,
      ..._,
      ...f,
      i
    ]
  }, k = {
    begin: /</,
    end: />/,
    keywords: "repeat each",
    contains: [
      ...c,
      i
    ]
  }, re = {
    begin: s(
      N(e(a, /\s*:/)),
      N(e(a, /\s+/, a, /\s*:/))
    ),
    end: /:/,
    relevance: 0,
    contains: [
      {
        className: "keyword",
        match: /\b_\b/
      },
      {
        className: "params",
        match: a
      }
    ]
  }, U = {
    begin: /\(/,
    end: /\)/,
    keywords: u,
    contains: [
      re,
      ...c,
      ...r,
      ...E,
      d,
      l,
      ...f,
      i,
      M
    ],
    endsParent: !0,
    illegal: /["']/
  }, le = {
    match: [
      /(func|macro)/,
      /\s+/,
      s(L.match, a, w)
    ],
    className: {
      1: "keyword",
      3: "title.function"
    },
    contains: [
      k,
      U,
      o
    ],
    illegal: [
      /\[/,
      /%/
    ]
  }, Ee = {
    match: [
      /\b(?:subscript|init[?!]?)/,
      /\s*(?=[<(])/
    ],
    className: { 1: "keyword" },
    contains: [
      k,
      U,
      o
    ],
    illegal: /\[|%/
  }, de = {
    match: [
      /operator/,
      /\s+/,
      w
    ],
    className: {
      1: "keyword",
      3: "title"
    }
  }, pe = {
    begin: [
      /precedencegroup/,
      /\s+/,
      C
    ],
    className: {
      1: "keyword",
      3: "title"
    },
    contains: [i],
    keywords: [
      ...fe,
      ...x
    ],
    end: /}/
  };
  for (const t of l.variants) {
    const h = t.contains.find((me) => me.label === "interpol");
    h.keywords = u;
    const p = [
      ...r,
      ...y,
      ...E,
      d,
      l,
      ..._
    ];
    h.contains = [
      ...p,
      {
        begin: /\(/,
        end: /\)/,
        contains: [
          "self",
          ...p
        ]
      }
    ];
  }
  return {
    name: "Swift",
    keywords: u,
    contains: [
      ...c,
      le,
      Ee,
      {
        beginKeywords: "struct protocol class extension enum actor",
        end: "\\{",
        excludeEnd: !0,
        keywords: u,
        contains: [
          n.inherit(n.TITLE_MODE, {
            className: "title.class",
            begin: /[A-Za-z$_][\u00C0-\u02B80-9A-Za-z$_]*/
          }),
          ...r
        ]
      },
      de,
      pe,
      {
        beginKeywords: "import",
        end: /$/,
        contains: [...c],
        relevance: 0
      },
      B,
      ...r,
      ...y,
      ...E,
      d,
      l,
      ..._,
      ...f,
      i,
      M
    ]
  };
}
export {
  ye as default
};
